const menuTabs = () => {

  const header = document.querySelector('.header');
  const body = document.querySelector('body');
  const tabs = document.querySelectorAll('.menu-tab');

  if (!tabs) {
    return;
  }

  const tabLinks = document.querySelectorAll('.item-tab');
  const main = document.querySelector('main');


  tabLinks.forEach((e) => {
    e.addEventListener('click', function () {
      let id = e.getAttribute('data-id');
      let tab = document.getElementById(id);
      if (tab.classList.contains('show')) {
        tab.classList.remove('show');
        header.classList.remove('header--opened');
      } else {
        tab.classList.add('show');
        tabs.forEach((i) => {
          if (i.id !== id) {
            i.classList.remove('show');
          }
        });
        header.classList.add('header--opened');
      }
    });
  });

  main.addEventListener('click', function () {
    tabs.forEach((e) => {
      e.classList.remove('show');
    });
    header.classList.remove('header--opened');
  });

  window.addEventListener('resize', function () {
    if (screen.width > 1330) {
      body.classList.remove('mobile-menu');
    }

    if (screen.width <= 1330 && !body.classList.contains('mobile-menu')) {
      tabs.forEach((e) => {
        e.classList.remove('show');
        header.classList.remove('header--opened');
      });
    }
  });
};

export {menuTabs};
